export const OtherRule = {
    "GetAgentID": "GetAgentId",
    "GetExtension":"GetExtension",
    "HangUp":"HangUp",
    "UpdateDataCall":"UpdateDataCall",
    "Mute":"Mute",
    "DTMF":"DTMF",
    "sendClientChatMessage":"sendClientChatMessage",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "getChatHistory":"getChatHistory",
    "UpdateDataCall":"UpdateDataCall",
    "GetUserName":"getUserName",
};


// WEBPACK FOOTER //
// ./src/BusinessRule/OtherRule.js